"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const core_1 = require("@material-ui/core");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const makeMyClasses = (transition, transitionDelay, inline, color, top) => ({
    root: {
        transition: `opacity ${transition}s`,
        transitionDelay: `opacity ${transitionDelay}s, height ${transition}s`,
        position: 'relative',
        pointerEvents: 'none',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        zIndex: 100,
        ['&.visible']: {
            opacity: 1,
            height: 'auto',
            overflow: 'visible',
        },
        ['&.whiteout']: {
            zIndex: 2000,
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'white',
        },
    },
    spinner: {
        position: inline ? undefined : 'absolute',
        top: inline ? undefined : top,
        left: inline ? undefined : 'calc(50% - 20px)',
        color: color.main,
    },
});
function Spinner(props) {
    const { whiteout = false, transition = 0.1, transitionDelay = 0, startDelay = 500, busy = false, inline = false, top = 20, children, color = lib_palette_1.default.primary, size = 40, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [transition, transitionDelay, inline, color, top]);
    const [showSpinner, setShowSpinner] = (0, react_1.useState)(false);
    const showSpinnerTimer = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (showSpinnerTimer.current)
            clearTimeout(showSpinnerTimer.current);
        if (busy)
            showSpinnerTimer.current = setTimeout(() => setShowSpinner(true), startDelay);
        else
            setShowSpinner(false);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [busy]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { style: {}, className: (0, web_css_1.cx)(myCss.root, whiteout ? 'whiteout' : '', busy ? 'visible' : '') }, showSpinner && (react_1.default.createElement(core_1.CircularProgress, { className: myCss.spinner, disableShrink: true, variant: "indeterminate", size: size }))),
        !busy && typeof children === 'function' && children(),
        typeof children !== 'function' && children));
}
exports.Spinner = Spinner;
exports.default = Spinner;
